import React from 'react'
import { PrimaryApplicationClickableIndicator } from '../../../components/primary-application'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { Role } from '@contrast-security-inc/base-types'

interface ReactPrimaryApplicationClickableIconProps {
  organizationID: string
  organizationRole: Role
  primaryApplication: {
    id: string
    name: string
    licensed: boolean
    role: Role
  }
  moduleCount: number
  refresh?: () => Promise<any>
}

function ReactPrimaryApplicationClickableIcon(
  props: ReactPrimaryApplicationClickableIconProps
) {
  if (!props.organizationID) {
    throw new Error('organizationID prop is required')
  }

  if (
    !props.primaryApplication ||
    !props.primaryApplication.id ||
    props.primaryApplication.licensed === undefined ||
    !props.primaryApplication.name
  ) {
    throw new Error('all primaryApplication attributes are required')
  }

  if (props.moduleCount === undefined) {
    throw new Error('moduleCount prop is required')
  }

  return <PrimaryApplicationClickableIndicator {...props} />
}

export const reactPrimaryApplicationClickableIcon =
  createNgReactBridgeDirective(
    'reactPrimaryApplicationIconClickable',
    [],
    ReactPrimaryApplicationClickableIcon,
    [
      'organizationID',
      'organizationRole',
      'primaryApplication',
      'moduleCount',
      'refresh'
    ]
  )
